import React, {useContext, useEffect, useState} from 'react';
import {AgentContext} from "../../context/agent-context.jsx";
import ValidateCnh from "../../../../../../components/validation/validate-cnh.jsx";
import {addDays, endOfDay, format, isAfter, isWithinInterval, startOfDay} from "date-fns";
import {Card} from "../../../../../../components/card/card.jsx";
import InputDateTime from "../../../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import Attach from "../../../../../../components/attach/attach.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";
import {FaCalendar} from "react-icons/fa";

const initialDateClass = {
    expirationCnh: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    carryDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    shotDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    psychoDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    crafDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    toxicologicalDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-2.25 right-2.5"} />},
    longGunLicenceDueDate: {divClass: "", faIcon: <FaCalendar className={"absolute top-[9px] right-[10px]"} />},
}

const Documents = () => {
    const {user, setUser, setAttachs, handleInputObject, handleDocsInputObject, setChanges} = useContext(AgentContext);
    const [dateClass, setDateClass] = useState(initialDateClass);
    const [isCnhValid, setIsCnhValid] = useState(true);

    const onChangeFile = (file, itemId) => {
        if (file) {
            if (file) {
                setAttachs((prevItems) => [...prevItems, file]);
                setUser(prev => ({...prev, documents: {...prev.documents, [`${itemId}File`]: file}}))
                typeof file != "string" ? setDocumentsChanges() : ""
            }
        }
    }

    const removeFile = (file, itemId) => {
        if (file) {
            setAttachs((prevItems) => prevItems.filter((item) => item.name !== file.name));
            setUser(prev => ({...prev, documents: {...prev.documents, [`${itemId}File`]: null}}))
            setDocumentsChanges();
        }
    }

    const handleDate = (id, value) => {
        const dateFormated = value ? format(value, "yyyy-MM-dd") : null
        if (user.documents[id] === dateFormated) return
        handleDocsInputObject("documents", dateFormated, id)
    }

    const onChange = (e) => {
        handleInputObject("documents", e);
        setDocumentsChanges();
    }

    const onChangeMultiSelect = (value) => {
        setUser(prev => ({
            ...prev, documents: {...prev.documents, categoryCnh: value.map(item => item.value)}
        }))

        setDocumentsChanges();
    }

    const setDocumentsChanges = () => {
        setChanges('documents');
    }

    const handleCondition = (givenDate, field) => {
        const todayStart = startOfDay(new Date());
        const givenDateEnd = givenDate ? endOfDay(givenDate) : null
        const almostDate = addDays(todayStart, 45);

        let divClass = "";
        let faIcon = <FaCalendar className={"absolute top-[9px] right-[10px]"}/>;
        if (givenDateEnd) {
            if (!isAfter(givenDateEnd, todayStart)) {
                divClass = "!text-[#dc4c64] !border-[#dc4c64]";
                faIcon = <FaTriangleExclamation color={"dc4c64"} className={"absolute top-[9px] right-[10px]"}/>
            } else if (isWithinInterval(givenDateEnd, {start: todayStart, end: almostDate})) {
                divClass = "!text-[#FC6D00] !border-[#FC6D00]";
                faIcon = <FaCircleExclamation color={"#FC6D00"} className={"absolute top-[9px] right-[10px]"}/>
            }
        }

        setDateClass(prev => ({
            ...prev, [field]: {...prev[field], divClass, faIcon}
        }));
    }

    useEffect(() => {
        const {documents} = user;

        const dateFields = ["expirationCnh", "carryDueDate", "shotDueDate", "psychoDueDate", "crafDueDate", "toxicologicalDueDate", "longGunLicenceDueDate"];

        dateFields.forEach(field => {
            const value = documents[field];
            const givenDate = value ?? null;
            handleCondition(givenDate, field);
        });

        if (documents.cnh) ValidateCnh(documents.cnh, setIsCnhValid);
    }, [user]);

    return (
        <div className={"h-[calc(100vh-131px)] overflow-x-hidden overflow-y-auto"}>
            <Card>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4 mb-4">
                        <div className="col-span-2">
                            <label className="form-label label-col">RG</label>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="rg" value={user.documents.rg} label="Número" onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="emitterRg" value={user.documents.emitterRg} label="Emissor"
                                      onChange={onChange}/>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"expeditionRg"}
                                selected={user.documents.expeditionRg}
                                label={"Data de emissão"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("expeditionRg", date)}
                            />
                        </div>
                        <div className="col-span-2"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "rg")} removeFile={removeFile} itemId={"rg"}
                                    attachId={user.documents.rgFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">CNH</label>
                        </div>
                        <div className="col-span-2 relative">
                            <InputForm
                                id="cnh"
                                label="Número"
                                value={user.documents.cnh}
                                inputClass={isCnhValid ? "" : "!text-[#dc4c64] !border-[#dc4c64]"}
                                labelClass={isCnhValid ? "" : "!text-[#dc4c64]"}
                                onChange={onChange}/>
                            {
                                !isCnhValid &&
                                <>
                                    <small className={"text-[#dc4c64] absolute top-[-14px] right-0"}>CNH inválida</small>
                                    <FaTriangleExclamation color={"#dc4c64"} className={"absolute top-[9px] right-[10px]"} />
                                </>
                            }
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"emitterCnh"}
                                selected={user.documents.emitterCnh}
                                label={"Data de emissão"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("emitterCnh", date)}/>
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"expirationCnh"}
                                selected={user.documents.expirationCnh}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("expirationCnh", date)}
                                inputClass={dateClass.expirationCnh?.divClass}
                                labelClass={dateClass.expirationCnh?.divClass}
                                customIcon={dateClass.expirationCnh?.faIcon}
                            />
                        </div>
                        <div className="col-span-2">
                            <SelectComponent
                                id="categoryCnh"
                                value={user.documents.categoryCnh ? user.documents.categoryCnh.map(item => {
                                    return {value: item, label: item}
                                }) : []}
                                options={optionsUtils.categoryCnh}
                                label={"Categoria"}
                                isMulti
                                onChange={onChangeMultiSelect}
                            />
                        </div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "cnh")} removeFile={removeFile} itemId={"cnh"}
                                    attachId={user.documents.cnhFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">CTPS</label>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="workRegister" value={user.documents.workRegister} label="Número"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="workSerie" value={user.documents.workSerie} label="Série"
                                      onChange={onChange}/>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"emitterWork"}
                                selected={user.documents.emitterWork}
                                label={"Data de emissão"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("emitterWork", date)}
                            />
                        </div>
                        <div className="col-span-2"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "work")} removeFile={removeFile} itemId={"work"}
                                    attachId={user.documents.workFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">PIS/PASEP</label>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="pisPasep" value={user.documents.pisPasep} label="Número"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-6"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "pis")} removeFile={removeFile} itemId={"pis"}
                                    attachId={user.documents.pisFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Título de eleitor</label>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="voterRegister" value={user.documents.voterRegister} label="Número"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="voterZone" value={user.documents.voterZone} label="Zona"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="voterSection" value={user.documents.voterSection} label="Seção"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "voter")} removeFile={removeFile} itemId={"voter"}
                                    attachId={user.documents.voterFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Porte de arma</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"carryShippingDate"}
                                selected={user.documents.carryShippingDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("carryShippingDate", date)}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"carryDueDate"}
                                selected={user.documents.carryDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("carryDueDate", date)}
                                inputClass={dateClass.carryDueDate?.divClass}
                                labelClass={dateClass.carryDueDate?.divClass}
                                customIcon={dateClass.carryDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-2">
                            <InputForm id="cautionNumber" value={user.documents.cautionNumber} label="Número da cautela"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="licenseNumber" value={user.documents.licenseNumber} label="Número do porte"
                                      onChange={onChange}/>
                        </div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "carry")} removeFile={removeFile} itemId={"carry"}
                                    attachId={user.documents.carryFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Exame de tiro</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"shotShippingDate"}
                                selected={user.documents.shotShippingDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("shotShippingDate", date)}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"shotDueDate"}
                                selected={user.documents.shotDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("shotDueDate", date)}
                                inputClass={dateClass.shotDueDate?.divClass}
                                labelClass={dateClass.shotDueDate?.divClass}
                                customIcon={dateClass.shotDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "shot")} removeFile={removeFile} itemId={"shot"}
                                    attachId={user.documents.shotFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Exame psicológico</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"psychoShippingDate"}
                                selected={user.documents.psychoShippingDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("psychoShippingDate", date)}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"psychoDueDate"}
                                selected={user.documents.psychoDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("psychoDueDate", date)}
                                inputClass={dateClass.psychoDueDate?.divClass}
                                labelClass={dateClass.psychoDueDate?.divClass}
                                customIcon={dateClass.psychoDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "psycho")} removeFile={removeFile} itemId={"psycho"}
                                    attachId={user.documents.psychoFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">CRAF</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"crafShippingDate"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("crafShippingDate", date)}
                                label={"Data de expedição"}
                                setInputValue={handleDate}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"crafDueDate"}
                                selected={user.documents.crafDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("crafDueDate", date)}
                                inputClass={dateClass.crafDueDate?.divClass}
                                labelClass={dateClass.crafDueDate?.divClass}
                                customIcon={dateClass.crafDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "craf")} removeFile={removeFile} itemId={"craf"}
                                    attachId={user.documents.crafFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Certificado de reservista</label>
                        </div>
                        <div className="col-span-2">
                            <InputForm id="reservistRaNumber" value={user.documents.reservistRaNumber}
                                      label="Número RA" onChange={onChange}/>
                        </div>

                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"reservistDate"}
                                selected={user.documents.reservistDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("reservistDate", date)}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "reservistCertificate")} removeFile={removeFile} itemId={"reservistCertificate"}
                                    attachId={user.documents.reservistCertificateFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Exame toxicológico</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"toxicologicalShippingDate"}
                                selected={user.documents.toxicologicalShippingDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("toxicologicalShippingDate", date)}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"toxicologicalDueDate"}
                                selected={user.documents.toxicologicalDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("toxicologicalDueDate", date)}
                                inputClass={dateClass.toxicologicalDueDate?.divClass}
                                labelClass={dateClass.toxicologicalDueDate?.divClass}
                                customIcon={dateClass.toxicologicalDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={(file) => onChangeFile(file, "toxicological")} removeFile={removeFile} itemId={"toxicological"}
                                    attachId={user.documents.toxicologicalFile}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-2">
                            <label className="form-label label-col">Habilitação para arma longa</label>
                        </div>
                        <div className={"col-span-2"}>
                            <InputDateTime
                                id={"longGunLicenceShippingDate"}
                                selected={user.documents.longGunLicenceShippingDate}
                                label={"Data de expedição"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("longGunLicenceShippingDate", date)}
                            />
                        </div>
                        <div className={"col-span-2 relative"}>
                            <InputDateTime
                                id={"longGunLicenceDueDate"}
                                selected={user.documents.longGunLicenceDueDate}
                                label={"Data de vencimento"}
                                dateFormat={"L"}
                                onChange={(date) => handleDate("longGunLicenceDueDate", date)}
                                inputClass={dateClass.longGunLicenceDueDate?.divClass}
                                labelClass={dateClass.longGunLicenceDueDate?.divClass}
                                customIcon={dateClass.longGunLicenceDueDate?.faIcon}
                            />
                        </div>
                        <div className="col-span-4"></div>
                        <div className="col-span-2">
                            <Attach onChangeFile={onChangeFile} removeFile={removeFile} itemId={"longGunLicence"}
                                    attachId={user.documents.longGunLicenceFile}/>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default Documents;